import type { ReactNode } from "react";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button/Button";
import { ErrorPanel } from "@/components/Errors/ErrorPanel";
import { IconAirplaneCrossed, IconHotelCrossed } from "@/components/Icons";

type Props = {
  scope: "flights" | "hotels";
  title: ReactNode;
  subtitle?: ReactNode;
  onClearFilterClick: () => void;
};

export const NoFilteringResults = ({
  scope,
  title,
  subtitle,
  onClearFilterClick,
}: Props) => {
  const intl = useIntl();

  return (
    <ErrorPanel
      icon={scope === "flights" ? IconAirplaneCrossed : IconHotelCrossed}
      primaryText={title}
      secondaryText={subtitle}
    >
      <Button
        onClick={onClearFilterClick}
        variant="outlined"
        borderRoundness="medium"
        color="primary"
        size="small"
      >
        {intl.formatMessage({
          defaultMessage: "Reset all filters",
          description: "Button to reset all filters",
        })}
      </Button>
    </ErrorPanel>
  );
};
